import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alerta-sessao',
  templateUrl: './alerta-sessao.component.html',
  styleUrls: ['./alerta-sessao.component.css']
})
export class AlertaSessaoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
